var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as Yup from 'yup';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Divider, TextField } from '@mui/material';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { PajakMethod, PajakType, PositionList, TransferMethod } from '../../Transfer/Transfer.enum';
import { SPKOptions, dummyPaymentMethodOptions, dummyPositionOptions, dummySPKTaxTypeOptions, dummyTaxMethodOptions, dummyTaxOptions, } from '../../Transfer/Transfer.constant';
import { useAddresses, useBankAccounts, } from '@src/app/pages/TalentPage/TalentHooks/TalentDetail.hooks';
import { useCompanies, useEmployees } from '@src/app/pages/LookupPage/LookupHooks/Lookup.hooks';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DrawerComponent from '@src/components/Atoms/Drawer/Drawer';
import { FormatYearMonthDate } from '@src/app/helper';
import Input from '@src/components/Atoms/Input/Input';
import InputFormik from '@src/components/Atoms/Formik/Input/InputFormik';
import MultiSelectFormik from '@src/components/Atoms/Formik/MultiSelect/MultiSelectFormik';
import SelectFormik from '@src/components/Atoms/Formik/Select/SelectFormik';
import TextAreaFormik from '@src/components/Atoms/Formik/TextArea/TextAreaFormik';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { useJob } from '@src/app/pages/JobPage/JobHooks/Job.hooks';
import { useProductCategory } from '@src/app/pages/ProductCategoryPage/ProductCategoryHooks/ProductCategory.hooks';
var TemplateSPKSchema = Yup.object().shape({
    companyPubId: Yup.string().required('Field belum diisi'),
    employeePubId: Yup.string().required('Field belum diisi'),
    productCategories: Yup.array().min(1, 'Isi minimal 1').required('Isi minimal 1').nullable(),
    date: Yup.string().required('Field belum diisi'),
    startDate: Yup.string().required('Field belum diisi'),
    endDate: Yup.string().required('Field belum diisi'),
    managerSKDate: Yup.string().when('option', {
        is: function (option) { return option === 'Manager'; },
        then: Yup.string().required('Field belum diisi'),
        otherwise: Yup.string().nullable(),
    }),
    companyName: Yup.string().when('option', {
        is: function (option) { return option === 'Company'; },
        then: Yup.string().required('Field belum diisi'),
        otherwise: Yup.string().nullable(),
    }),
    companyDivision: Yup.string().when('option', {
        is: function (option) { return option === 'Company'; },
        then: Yup.string().required('Field belum diisi'),
        otherwise: Yup.string().nullable(),
    }),
    companyAdress: Yup.string().when('option', {
        is: function (option) { return option === 'Company'; },
        then: Yup.string().required('Field belum diisi'),
        otherwise: Yup.string().nullable(),
    }),
    talentAddressPubId: Yup.string().required('Field belum diisi'),
    talentBankAccountPubId: Yup.string().required('Field belum diisi'),
    paymentType: Yup.string().required('Field belum diisi'),
    pajakType: Yup.string().required('Field belum diisi'),
    pajakMethod: Yup.string().when('pajakType', {
        is: function (pajakType) { return pajakType === PajakType.PAJAK; },
        then: Yup.string().required('Field belum diisi'),
    }),
    pajakCategory: Yup.string().when('pajakMethod', {
        is: function (pajakMethod) { return pajakMethod === PajakMethod.INCLUDED; },
        then: Yup.string().required('Field belum diisi'),
    }),
    totalFee: Yup.string().required('Field belum diisi'),
    paymentestimate: Yup.string().required('Field harus diisi'),
    Email: Yup.string().required('Field belum diisi').max(100, 'Maksimal 100 karakter'),
    PhoneNumber: Yup.string()
        .required('Field belum diisi')
        .min(10, 'Minimal 10 karakter')
        .max(15, 'Maksimal 15 karakter')
        .matches(/^(\S+$)/g, 'Tidak boleh ada spasi'),
    WhatsApp: Yup.string()
        .required('Field belum diisi')
        .min(10, 'Minimal 10 karakter')
        .max(15, 'Maksimal 15 karakter')
        .matches(/^(\S+$)/g, 'Tidak boleh ada spasi'),
});
var TemplateSPK = function (_a) {
    var isOpen = _a.isOpen, handleClose = _a.handleClose, id = _a.id, talentId = _a.talentId, record = _a.record;
    var _b = useState(true), isDisabled = _b[0], setIsDisabled = _b[1];
    var _c = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: "[[\"talent.pubId\", \"".concat(talentId, "\"]]"),
        initialFilterBy: "[[\"recordStatus\", \"Active\"]]",
    }), filterAddress = _c[0], setFilterAddress = _c[1];
    var _d = useState({
        page: 1,
        pageSize: 100,
        keyword: '',
        filterBy: '[]',
        initialFilterBy: "[[]]",
    }), filterEmployee = _d[0], setFilterEmployee = _d[1];
    //company
    var _e = useState(0), companyValue = _e[0], setCompanyValue = _e[1];
    var _f = useState([]), selectedCompany = _f[0], setSelectedCompany = _f[1];
    var companies = useCompanies().companies;
    var optionCompanies = companies &&
        companies.data &&
        companies.data.length > 0 &&
        companies.data.map(function (company) { return ({
            label: company.name,
            value: company.pubId,
        }); });
    var onChangeCompany = function (e) {
        setSelectedCompany(e);
        TemplateSPKFormik.setFieldValue('companyPubId', e.value);
        filterEmployee['filterBy'] = "[[\"company.pubId\", \"".concat(e.value, "\"]]");
        setCompanyValue(companyValue + 1);
    };
    useEffect(function () {
        refetchEmployee();
        companyValue == 0 ? setIsDisabled(true) : setIsDisabled(false);
    }, [companyValue]);
    //employee
    var _g = useEmployees(filterEmployee), employees = _g.employees, refetchEmployee = _g.refetch;
    var optionEmployees = employees &&
        employees.data &&
        employees.data.length > 0 &&
        employees.data.map(function (employee) { return ({
            name: employee.name,
            value: employee.pubId,
        }); });
    //date
    var _h = useState(dayjs().format('YYYY-MM-DD').toString()), date = _h[0], setDate = _h[1];
    var _j = useState(dayjs().format('YYYY-MM-DD').toString()), startDate = _j[0], setStartDate = _j[1];
    var _k = useState(dayjs().format('YYYY-MM-DD').toString()), endDate = _k[0], setEndDate = _k[1];
    var _l = useState(dayjs().format('YYYY-MM-DD').toString()), managerSKDate = _l[0], setManagerSKDate = _l[1];
    var _m = useState(dayjs().format('YYYY-MM-DD').toString()), companySKDate = _m[0], setCompanySKDate = _m[1];
    var onChangeDate = function (e, name) {
        var event = { target: { name: '', value: null } };
        event.target.value = e == null ? '' : FormatYearMonthDate(e);
        TemplateSPKFormik.setFieldValue(name, event.target.value);
        switch (name) {
            case 'startDate':
                setStartDate(event.target.value);
                setEndDate(dayjs(event.target.value.toString()).add(2, 'months').format('YYYY-MM-DD').toString());
                TemplateSPKFormik.values.endDate = dayjs(event.target.value.toString())
                    .add(2, 'months')
                    .format('YYYY-MM-DD')
                    .toString();
                break;
            case 'endDate':
                return setEndDate(event.target.value);
            case 'managerSKDate':
                return setManagerSKDate(event.target.value);
            case 'companySKDate':
                return setCompanySKDate(event.target.value);
            default:
                return setDate(event.target.value);
        }
    };
    //productCategory
    var _o = useState([]), selectedProductCategory = _o[0], setSelectedProductCategory = _o[1];
    var _p = useProductCategory(), productCategory = _p.productCategory, isLoadingProductCategory = _p.isLoading, errorSocialMedia = _p.error;
    var optionProductCategory = productCategory &&
        productCategory.length > 0 &&
        productCategory.map(function (category) { return ({
            label: category.name,
            value: category.pubId,
        }); });
    var onChangeProductCategory = function (e) {
        setSelectedProductCategory(e);
        var selected = e.map(function (obj) { return obj.value; });
        TemplateSPKFormik.setFieldValue('productCategories', selected);
    };
    //address
    var _q = useAddresses(talentId, !!talentId, filterAddress), addresses = _q.addresses, isLoadingAddress = _q.isLoading;
    var _r = useState(), selectedAddress = _r[0], setSelectedAddress = _r[1];
    var optionAddress = useMemo(function () {
        return __spreadArray([], ((addresses === null || addresses === void 0 ? void 0 : addresses.map(function (address) { return ({
            label: address.address,
            value: address.pubId,
        }); })) || []), true);
    }, [addresses]);
    var onChangeAddress = function (e) {
        setSelectedAddress(e);
        TemplateSPKFormik.setFieldValue('talentAddressPubId', e.value);
    };
    // bankAccount
    var _s = useBankAccounts(talentId, !!talentId, filterAddress), bankAccounts = _s.bankAccounts, isLoadingBankAccount = _s.isLoading;
    var _t = useState(), selectedBankAccount = _t[0], setSelectedBankAccount = _t[1];
    var optionBankAccount = useMemo(function () {
        return __spreadArray([], ((bankAccounts === null || bankAccounts === void 0 ? void 0 : bankAccounts.map(function (bank) { return ({
            label: "".concat(bank.accountName, " - ").concat(bank.accountNumber, " - ").concat(bank.bank.name),
            value: bank.pubId,
        }); })) || []), true);
    }, [bankAccounts]);
    var onChangeBankAccount = function (e) {
        setSelectedBankAccount(e);
        TemplateSPKFormik.setFieldValue('talentBankAccountPubId', e.value);
    };
    //template
    var TemplateSPKValues = {
        companyPubId: '',
        employeePubId: '',
        productCategories: null,
        date: date ? date : '',
        startDate: startDate ? startDate : '',
        endDate: endDate ? endDate : '',
        option: 'Personal',
        titlePosition: '',
        // managerName: '',
        // managerKTPNumber: '',
        managerSKDate: managerSKDate ? managerSKDate : '',
        companySKDate: companySKDate ? companySKDate : '',
        // managerKTPAddress: '',
        // managerNPWPNumber:'',
        companyName: '',
        companyDivision: '',
        companyAdress: '',
        companyNote: '',
        talentNote: '',
        talentAddressPubId: '',
        talentBankAccountPubId: '',
        paymentType: '',
        terminNumber: 0,
        perTermPercentages: [
            {
                percentage: 0,
                paymentDue: '',
            },
        ],
        pajakMethod: '',
        pajakType: '',
        pajakCategory: '',
        totalFee: record.totalFee ? record.totalFee : '',
        paymentestimate: '',
        PhoneNumber: '',
        Email: '',
        WhatsApp: '',
    };
    //termin number
    var _u = useState(TemplateSPKValues), initialFormValues = _u[0], setInitialFormValues = _u[1];
    var _v = useState(1), countTermin = _v[0], setCountTermin = _v[1];
    var handleChangeTermin = function (e) {
        setCountTermin(+e.target.value);
        var PerTermPercentage = {
            percentage: 0,
            paymentDue: '',
        };
        var PerTermPercentages = Array.from({ length: +e.target.value }, function (_, i) { return i + 1; }).map(function (i) { return PerTermPercentage; });
        setInitialFormValues(function (prevState) { return (__assign(__assign({}, prevState), { paymentType: TemplateSPKFormik.values.paymentType, perTermPercentages: __spreadArray([], PerTermPercentages, true) })); });
    };
    var templateSPKJob = useJob().templateSPKJob;
    var TemplateSPKFormik = useFormik({
        initialValues: initialFormValues,
        enableReinitialize: false,
        validationSchema: TemplateSPKSchema,
        onSubmit: function (values, _a) {
            var resetForm = _a.resetForm;
            return __awaiter(void 0, void 0, void 0, function () {
                var formValues, companyPubId, employeePubId, productCategories, date, startDate, endDate, option, 
                // managerName,
                // managerKTPNumber,
                managerSKDate, companySKDate, titlePosition, 
                // managerKTPAddress,
                // managerNPWPNumber,
                companyName, companyDivision, companyAdress, companyNote, talentNote, talentAddressPubId, talentBankAccountPubId, pajakMethod, pajakType, pajakCategory, totalFee, perTermPercentages, value, finalTotalFee, finalFormValue, pajakFormValue, formData, file, FILE_API_BASE_URL, url, e_1, error;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            formValues = __assign({ id: id }, values);
                            companyPubId = formValues.companyPubId, employeePubId = formValues.employeePubId, productCategories = formValues.productCategories, date = formValues.date, startDate = formValues.startDate, endDate = formValues.endDate, option = formValues.option, managerSKDate = formValues.managerSKDate, companySKDate = formValues.companySKDate, titlePosition = formValues.titlePosition, companyName = formValues.companyName, companyDivision = formValues.companyDivision, companyAdress = formValues.companyAdress, companyNote = formValues.companyNote, talentNote = formValues.talentNote, talentAddressPubId = formValues.talentAddressPubId, talentBankAccountPubId = formValues.talentBankAccountPubId, pajakMethod = formValues.pajakMethod, pajakType = formValues.pajakType, pajakCategory = formValues.pajakCategory, totalFee = formValues.totalFee, perTermPercentages = formValues.perTermPercentages, value = __rest(formValues, ["companyPubId", "employeePubId", "productCategories", "date", "startDate", "endDate", "option", "managerSKDate", "companySKDate", "titlePosition", "companyName", "companyDivision", "companyAdress", "companyNote", "talentNote", "talentAddressPubId", "talentBankAccountPubId", "pajakMethod", "pajakType", "pajakCategory", "totalFee", "perTermPercentages"]);
                            finalTotalFee = typeof totalFee == 'string'
                                ? totalFee.replace(/\./g, '')
                                : totalFee.toString().replaceAll(/\./g, '');
                            if (perTermPercentages.length > 0) {
                                perTermPercentages.map(function (item) {
                                    item.percentage = Number(item.percentage);
                                });
                            }
                            finalFormValue = formValues;
                            pajakFormValue = {};
                            if (pajakType === PajakType.PAJAK) {
                                pajakFormValue = {
                                    pajakType: pajakType,
                                    pajakMethod: pajakMethod,
                                    pajakCategory: pajakCategory, //PPh21
                                };
                            }
                            else {
                                pajakFormValue = {
                                    pajakType: pajakType,
                                    pajakCategory: '',
                                };
                            }
                            formData = __assign(__assign(__assign({}, finalFormValue), pajakFormValue), { totalFee: finalTotalFee });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, templateSPKJob(formData)];
                        case 2:
                            file = _b.sent();
                            handleClose();
                            FILE_API_BASE_URL = process.env.NEXUS_FILE_API_URL;
                            url = "".concat(FILE_API_BASE_URL, "/").concat(file.pubId, "/download");
                            window.open(url, '_blank', 'noreferrer');
                            return [3 /*break*/, 5];
                        case 3:
                            e_1 = _b.sent();
                            error = e_1.response.message;
                            toast.error(error);
                            return [3 /*break*/, 5];
                        case 4:
                            resetForm();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
    });
    var isInputOK = useMemo(function () {
        return (TemplateSPKFormik.values.companyPubId !== '' &&
            TemplateSPKFormik.values.date !== '' &&
            TemplateSPKFormik.values.employeePubId !== '' &&
            TemplateSPKFormik.values.endDate !== '' &&
            TemplateSPKFormik.values.managerSKDate !== '' &&
            TemplateSPKFormik.values.option !== '' &&
            TemplateSPKFormik.values.pajakType !== '' &&
            TemplateSPKFormik.values.paymentType !== '' &&
            TemplateSPKFormik.values.productCategories !== null &&
            TemplateSPKFormik.values.startDate !== '' &&
            TemplateSPKFormik.values.talentAddressPubId !== '' &&
            TemplateSPKFormik.values.talentBankAccountPubId !== '' &&
            // TemplateSPKFormik.values.totalFee > 0 &&
            TemplateSPKFormik.values.Email !== '' &&
            TemplateSPKFormik.values.PhoneNumber !== '' &&
            TemplateSPKFormik.values.WhatsApp !== '');
    }, [TemplateSPKFormik.values]);
    return (_jsx(DrawerComponent, __assign({ open: isOpen, size: 'LG', handleClose: handleClose, title: 'Template SPK' }, { children: _jsxs("form", __assign({ className: 'form w-100', onSubmit: TemplateSPKFormik.handleSubmit, noValidate: true, id: 'template-SPK-form' }, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "Date " })), _jsx(DatePicker, { value: date, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'date');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "Start Date " })), _jsx(DatePicker, { value: startDate, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'startDate');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "End Date " })), _jsx(DatePicker, { value: endDate, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'endDate');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Pihak', name: 'option', formik: TemplateSPKFormik, optionList: SPKOptions, isRequired: true }) })), (TemplateSPKFormik.values.option === 'Company') && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Position', name: 'titlePosition', formik: TemplateSPKFormik, optionList: dummyPositionOptions, isRequired: true }) }))), (TemplateSPKFormik.values.option === 'Company') && (_jsx(InputFormik, { label: 'Nama Manajer', type: 'text', placeholder: 'Nama Manajer', name: 'managerName', formik: TemplateSPKFormik, isRequired: true })), (TemplateSPKFormik.values.option === 'Company' && TemplateSPKFormik.values.titlePosition === PositionList.manager) && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: "Company SK Date " })), _jsx(DatePicker, { value: companySKDate, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                    onChangeDate(e, 'companySKDate');
                                }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) }))), TemplateSPKFormik.values.option === 'Manager' && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: [_jsxs("label", __assign({ className: 'form-label fs-6 fw-bolder required text-dark' }, { children: ["Tanggal SK Manajer", ' '] })), _jsx(DatePicker, { value: managerSKDate, inputFormat: 'DD/MM/YYYY', dayOfWeekFormatter: function (day) { return day; }, onChange: function (e) {
                                        onChangeDate(e, 'managerSKDate');
                                    }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { className: 'product-datepicker form-control' }))); } })] })) })) })), TemplateSPKFormik.values.option === 'Company' && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Nama Perusahaan', type: 'text', placeholder: 'Nama Perusahaan', name: 'companyName', formik: TemplateSPKFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Divisi Perusahaan', type: 'text', placeholder: 'Divisi Perusahaan', name: 'companyDivision', formik: TemplateSPKFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Alamat Perusahaan', placeholder: 'Alamat Perusahaan', name: 'companyAdress', formik: TemplateSPKFormik, isRequired: true }) }))] })), optionCompanies && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'companyPubId', label: 'Company', formik: TemplateSPKFormik, isMulti: false, isRequired: true, options: optionCompanies, value: selectedCompany, onchange: onChangeCompany }) }))] })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'No. Telp', type: 'text', placeholder: 'No. Telp', name: 'PhoneNumber', formik: TemplateSPKFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Email', type: 'email', placeholder: 'Email', name: 'Email', formik: TemplateSPKFormik, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Whatsapp', type: 'text', placeholder: 'Whatsapp', name: 'WhatsApp', formik: TemplateSPKFormik, isRequired: true }) })), optionEmployees && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Employee', name: 'employeePubId', formik: TemplateSPKFormik, optionList: optionEmployees, isRequired: true, disabled: isDisabled }) }))), optionProductCategory && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'productCategories', label: 'Kategori Produk', formik: TemplateSPKFormik, isMulti: true, isRequired: true, options: optionProductCategory, value: selectedProductCategory, onchange: onChangeProductCategory }) }))), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Untuk Diperhatikan Company', placeholder: 'Untuk Diperhatikan Company', name: 'companyNote', formik: TemplateSPKFormik }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: 'Untuk Diperhatikan Talent', placeholder: 'Untuk Diperhatikan Talent', name: 'talentNote', formik: TemplateSPKFormik }) })), _jsx(Divider, {}), optionAddress && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'talentAddressPubId', label: 'Alamat', formik: TemplateSPKFormik, isMulti: false, options: optionAddress, value: selectedAddress ? [selectedAddress] : [], onchange: onChangeAddress, isRequired: true }) }))), optionBankAccount && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(MultiSelectFormik, { name: 'talentBankAccountPubId ', label: 'No Rekening', formik: TemplateSPKFormik, isMulti: false, options: optionBankAccount, value: selectedBankAccount ? [selectedBankAccount] : [], onchange: onChangeBankAccount, isRequired: true }) }))), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Metode Pembayaran', name: 'paymentType', formik: TemplateSPKFormik, optionList: dummyPaymentMethodOptions, isRequired: true }) })), TemplateSPKFormik.values.paymentType === TransferMethod.PERTERM && (_jsxs("div", __assign({ className: 'my-5' }, { children: [_jsx("label", __assign({ className: 'form-label fs-6 fw-bolder text-dark' }, { children: "Jumlah Termin" })), _jsx(Input, { placeholder: 'Jumlah Termin', type: 'text', name: 'terminNumber', value: countTermin, onChange: handleChangeTermin })] }))), TemplateSPKFormik.values.paymentType === TransferMethod.PERTERM &&
                    initialFormValues &&
                    initialFormValues.perTermPercentages &&
                    initialFormValues.perTermPercentages.length > 0 &&
                    initialFormValues.perTermPercentages.map(function (perTermPercentage, index) { return (_jsxs(Fragment, { children: [_jsx("div", __assign({ className: 'mt-5' }, { children: _jsxs("div", __assign({ className: 'd-flex align-items-center gap-2' }, { children: [_jsx("div", __assign({ style: { flex: 1 } }, { children: _jsx(InputFormik, { label: "Percentage #".concat(index + 1), type: 'number', placeholder: 'Percentage', name: "perTermPercentages[".concat(index, "].percentage"), formik: TemplateSPKFormik, isRequired: true }) })), _jsx("span", __assign({ className: 'mt-2', style: { fontWeight: 'bold' } }, { children: "%" }))] })) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(TextAreaFormik, { label: "Payment Due #".concat(index + 1), placeholder: 'Payment Due', name: "perTermPercentages[".concat(index, "].paymentDue"), formik: TemplateSPKFormik, isRequired: true }) }))] }, index)); }), _jsx(Divider, {}), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Tipe Pajak', name: 'pajakType', formik: TemplateSPKFormik, optionList: dummyTaxOptions, isRequired: true }) })), TemplateSPKFormik.values.pajakType === PajakType.PAJAK && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Metode Pajak', name: 'pajakMethod', formik: TemplateSPKFormik, optionList: dummyTaxMethodOptions, isRequired: true }) }))), TemplateSPKFormik.values.pajakType === PajakType.PAJAK && (_jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Kategori Pajak', name: 'pajakCategory', formik: TemplateSPKFormik, optionList: dummySPKTaxTypeOptions, 
                        // disabled={true} //auto pph21
                        isRequired: true }) }))), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(InputFormik, { label: 'Total Amount', type: 'text', placeholder: 'Total Amount', name: 'totalFee', formik: TemplateSPKFormik, formatNumber: true, isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsx(SelectFormik, { label: 'Estimasi Pembayaran', name: 'paymentestimate', formik: TemplateSPKFormik, optionList: [
                            { name: '7 Hari Kerja', value: '7' },
                            { name: '14 Hari Kerja', value: '14' },
                        ], isRequired: true }) })), _jsx("div", __assign({ className: 'my-5' }, { children: _jsxs("div", __assign({ style: { textAlign: 'right' } }, { children: [_jsx("button", __assign({ type: 'button', className: 'btn btn-secondary btn-active-light-primary btn-sm', onClick: handleClose, disabled: TemplateSPKFormik.isSubmitting, style: { marginRight: '1rem' } }, { children: _jsx("span", __assign({ className: 'indicator-label' }, { children: "Batal" })) })), _jsxs("button", __assign({ type: 'submit', className: 'btn btn-primary btn-sm', disabled: TemplateSPKFormik.isSubmitting || !isInputOK }, { children: [!TemplateSPKFormik.isSubmitting && _jsx("span", __assign({ className: 'indicator-label' }, { children: "Simpan" })), TemplateSPKFormik.isSubmitting && (_jsxs("span", __assign({ className: 'indicator-progress', style: { display: 'block' } }, { children: ["Mohon tunggu...", _jsx("span", { className: 'spinner-border spinner-border-sm align-middle ms-2' })] })))] }))] })) }))] })) })));
};
export default TemplateSPK;
